import "../../shared/config/isInIframe"


// WEBPACK FOOTER //
// ./app/webpack/frontend/config/isInIframe.js